export const SUGGESTED_FILTERS_CONSOLIDATION_EXPERIMENT =
  'car-merch-ui-srp-suggested-filters-consolidation';

export const SUGGESTED_FILTERS_CONSOLIDATION_TREATMENT_BUCKETS: Array<string> =
  ['around-split', 'around-standard', 'limit-split', 'limit-standard'];
